import React, { useEffect, useState } from "react";
import { ArrowL, ArrowR } from "../../../components/Icons";
import { OnlDropdown, CardContainer } from "../../../components";
import Dropdown from "react-bootstrap/Dropdown"

export default function CustomDropdownTest(props) {

  const onClickBsDD = (e) => {
    e.preventDefault()
    console.log(e.target.name)
  }

  return (
    <CardContainer>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <OnlDropdown title="Custom DropDown Test" id="test1">
          <OnlDropdown.Item onClick={() => console.log('Item 1')}><ArrowL /> Sample 1</OnlDropdown.Item>
          <OnlDropdown.Item onClick={() => console.log('Item 2')}><ArrowR /> Sample 1</OnlDropdown.Item>
        </OnlDropdown>

        <OnlDropdown title="Custom DropDown Test2" id="test2">
          <OnlDropdown.Item onClick={() => console.log('Item 3')}><ArrowR /> Sample 3</OnlDropdown.Item>
          <OnlDropdown.Item onClick={() => console.log('Item 4')}><ArrowR /> Sample 4</OnlDropdown.Item>
        </OnlDropdown>

        {/* <hr/> */}

        {/* Bootstrap 예제 */}
        <Dropdown>
          <Dropdown.Toggle
            // as={CustomToggle} 
            style={{ backgroundColor: 'transparent', border: "none", color: "#333" }}
            id="dropdown-custom-components"
          >
            Bootstrap Dropdown Example
          </Dropdown.Toggle>
          <Dropdown.Menu
          // as={CustomMenu}
          >
            <Dropdown.Item eventKey="1" onClick={onClickBsDD} name="red">Red</Dropdown.Item>
            <Dropdown.Item eventKey="2" onClick={onClickBsDD} name="blue">Blue</Dropdown.Item>
            <Dropdown.Item eventKey="3" onClick={onClickBsDD} name="orange">Orange</Dropdown.Item>
            <Dropdown.Item eventKey="4" onClick={onClickBsDD} name="red-orange">Red-Orange</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </CardContainer>
  )

}

